import {
    NinchatActionType,
    NinchatGetQueueStatsAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const getQueueStats = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatGetQueueStatsAction}`,
    async (arg: NinchatActionParams<NinchatGetQueueStatsAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatGetQueueStatsAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
